import { ModuleWithProviders, NgModule } from '@angular/core';
import { PitchPlaylistService, PitchPlaylistStore, PitchPlaylistQuery } from './state';
import { CommonModule } from '@angular/common';

@NgModule({
  imports: [CommonModule],
  exports: [CommonModule],
  declarations: []
})
export class PitchPlaylistModule {
  static forRoot(): ModuleWithProviders<PitchPlaylistModule> {
    return {
      ngModule: PitchPlaylistModule,
      providers: [PitchPlaylistService, PitchPlaylistStore, PitchPlaylistQuery]
    };
  }
}
